import React, { useEffect, useState } from "react";
import About from "./About.jsx";
import Product from "./Product.jsx";
import IndustriesSection from "./IndustriesSection.jsx";
import Feature from "./ProductFeature.jsx"
import Facilities from "./Facilities.jsx";
import Testimonial from "./Testinomial.jsx";
import Contact from "./Contact.jsx";
import WhyChooseKSU from "./WhyChooseKSU.jsx";
import Home from "./Home.jsx";

const bannerImages = ["Product.svg", "home2.jpg", "home3.jpg"];

function Homepage() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div id="home"><Home /></div>
      <div id="about"><About /></div>
      <div id="product"><Product /></div>
      <div id="whychooseksu"><WhyChooseKSU /></div>
      <div id="industry"><IndustriesSection /></div>
      <div id="feature"><Feature /></div>
      <div id="facility"><Facilities /></div>
      <div id="testimonial"><Testimonial /></div>
      <div id="contact"><Contact /></div>
    </>
  );
}

export default Homepage;
